import { TileIds } from '../../util/tileEnums';
import {
  getInNetworkFamilyDeductible,
  getOutOfNetworkFamilyDeductible,
  getInNetworkIndividualDeductible,
  getOutOfNetworkIndividualDeductible,
  getInNetworkIndividualOutOfPocketMax,
  getInNetworkFamilyOutOfPocketMax,
  getOutOfNetworkIndividualOutOfPocketMax,
  getOutOfNetworkFamilyOutOfPocketMax,
} from './insuranceDetails';

const getDiffBetweenAppliedAndLimitValue = (applied: any, max: any) =>
  parseInt(max, 10) - parseInt(applied, 10);

const getAppliedAndMaxTileValues = (tile: any, insuranceDetails: any) => {
  switch (tile.id) {
    case TileIds.DEDUCTIBLE_PROGRESS_IN_NETWORK_INDIVIDUAL_DEDUCTIBLE: {
      return getInNetworkIndividualDeductible(insuranceDetails);
    }
    case TileIds.DEDUCTIBLE_PROGRESS_IN_NETWORK_FAMILY_DEDUCTIBLE: {
      return getInNetworkFamilyDeductible(insuranceDetails);
    }
    case TileIds.DEDUCTIBLE_PROGRESS_OUT_OF_NETWORK_INDIVIDUAL_DEDUCTIBLE: {
      return getOutOfNetworkIndividualDeductible(insuranceDetails);
    }
    case TileIds.DEDUCTIBLE_PROGRESS_OUT_OF_NETWORK_FAMILY_DEDUCTIBLE: {
      return getOutOfNetworkFamilyDeductible(insuranceDetails);
    }
    case TileIds.OUT_OF_POCKET_MAX_IN_NETWORK_INDIVIDUAL_MAX: {
      return getInNetworkIndividualOutOfPocketMax(insuranceDetails);
    }
    case TileIds.OUT_OF_POCKET_MAX_IN_NETWORK_FAMILY_MAX: {
      return getInNetworkFamilyOutOfPocketMax(insuranceDetails);
    }
    case TileIds.OUT_OF_POCKET_MAX_OUT_OF_NETWORK_INDIVIDUAL_MAX: {
      return getOutOfNetworkIndividualOutOfPocketMax(insuranceDetails);
    }
    case TileIds.OUT_OF_POCKET_MAX_OUT_OF_NETWORK_FAMILY_MAX: {
      return getOutOfNetworkFamilyOutOfPocketMax(insuranceDetails);
    }
    default:
      return null;
  }
};

const formatValueForDisplay = (value: any) => value && parseInt(value, 10).toLocaleString();

export { getDiffBetweenAppliedAndLimitValue, getAppliedAndMaxTileValues, formatValueForDisplay };
